exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-067db493] .suspected {\n  background: #ff3b00;\n}\n[data-v-067db493] .off-line {\n  background: #979797;\n}\n[data-v-067db493] .tool-tip {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n}\n.table-small[data-v-067db493] {\n  padding: 16px 10px 12px 10px;\n}\n.row[data-v-067db493] {\n  height: 33%;\n}\n.row.header[data-v-067db493] {\n    background: rgba(7, 56, 236, 0.25);\n}\n.row .flex-center[data-v-067db493] {\n    height: 100%;\n}\n.row[data-v-067db493]:nth-child(3) {\n    background: rgba(255, 255, 255, 0.15);\n}\n", ""]);

// exports
